__turbopack_context__.v({
  "avatar": "index-module-scss-module__SV_3UG__avatar",
  "budget": "index-module-scss-module__SV_3UG__budget",
  "budgetLabel": "index-module-scss-module__SV_3UG__budgetLabel",
  "card": "index-module-scss-module__SV_3UG__card",
  "cardDescription": "index-module-scss-module__SV_3UG__cardDescription",
  "cardTitle": "index-module-scss-module__SV_3UG__cardTitle",
  "carousel": "index-module-scss-module__SV_3UG__carousel",
  "container": "index-module-scss-module__SV_3UG__container",
  "description": "index-module-scss-module__SV_3UG__description",
  "eyebrow": "index-module-scss-module__SV_3UG__eyebrow",
  "fixImage": "index-module-scss-module__SV_3UG__fixImage",
  "imageStage": "index-module-scss-module__SV_3UG__imageStage",
  "meta": "index-module-scss-module__SV_3UG__meta",
  "primaryImageFrame": "index-module-scss-module__SV_3UG__primaryImageFrame",
  "secondaryImageFrame": "index-module-scss-module__SV_3UG__secondaryImageFrame",
  "section": "index-module-scss-module__SV_3UG__section",
  "stylist": "index-module-scss-module__SV_3UG__stylist",
  "title": "index-module-scss-module__SV_3UG__title",
});
